<template>

  <div class="position-relative w-100 vh-100 d-flex align-items-center justify-content-center bg-white">
    <!-- Back Button -->
    <button class="position-absolute top-0 start-0 m-3 btn btn-outline-secondary">
      ⬅ <!-- Left arrow icon -->
    </button>

    <!-- Close Button -->
    <button v-if="isFullScreen" class="position-absolute top-0 start-50 translate-middle-x mt-3 btn btn-outline-secondary rounded-circle" 
      @click="stop">
      ✖ <!-- Close icon -->
    </button>

    <!-- Start Button -->
    <button v-if="!isFullScreen" class="position-absolute top-0 start-50 translate-middle-x mt-3 btn btn-outline-secondary rounded-circle" 
      @click="start">
      FULL SCREEN 
    </button>

    <!-- Large Bottom Left Button -->
    <div class="position-absolute bottom-0 start-0 w-25 h-25 m-3 btn btn-secondary rounded shadow-lg px-4 py-3"
    style=" background-color: ivory;"
      @click="sendMessage('OK')"
      :disabled="!enableButtons">
     </div>

    <!-- Directional Pad -->
    <!-- <div class="position-absolute top-0 bottom-0 end-0 m-1 d-grid gap-3" style="grid-template-columns: repeat(3, auto); grid-template-rows: repeat(3, auto);">
      <button class="btn btn-outline-secondary m-3" style="grid-column: 2;" @click="sendMessage('UP')" :disabled="!enableButtons">⬆</button> 
      <button class="btn btn-outline-secondary m-3" style="grid-column: 1; grid-row: 2;" @click="sendMessage('LEFT')" :disabled="!enableButtons">⬅</button> 
      <button class="btn btn-outline-secondary m-3" style="grid-column: 3; grid-row: 2;" @click="sendMessage('RIGHT')" :disabled="!enableButtons">➡</button> 
      <button class="btn btn-outline-secondary m-3" style="grid-column: 2; grid-row: 3;" @click="sendMessage('DOWN')" :disabled="!enableButtons">⬇</button> 
    </div> -->

<!-- Directional Pad Grid -->
<div class="position-absolute end-0 d-grid align-self-start" style="height: 100%; grid-template-columns: 1fr 1fr 1fr; grid-template-rows: 1fr 1fr 1fr;width:40%;">
      <div class="border border-secondary btn btn-secondary rounded shadow-lg px-4 py-3" style="grid-column: 2; grid-row: 1; background-color: ivory;" @click="sendMessage('UP')" ></div>
      <div class="border border-secondary btn btn-secondary rounded shadow-lg px-4 py-3" style="grid-column: 1; grid-row: 2; background-color: ivory;" @click="sendMessage('LEFT')" ></div>
      <div class="border border-secondary btn btn-secondary rounded shadow-lg px-4 py-3" style="grid-column: 3; grid-row: 2; background-color: ivory;" @click="sendMessage('RIGHT')" ></div>
      <div class="border border-secondary btn btn-secondary rounded shadow-lg px-4 py-3" style="grid-column: 2; grid-row: 3; background-color: ivory;" @click="sendMessage('DOWN')" ></div>
    </div>
</div>
</template>
<style scoped>
@import "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css";

button {
  background-color: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(5px);
}

</style>
<script>


export default {
  components: {
    
  },
  data() {
    return  {
      ws: null,
      messages: [],
      reconnectAttempts: 0,
      isFullScreen: false,
      enableButtons: true
    }
  },
    methods: {
      start() {
        this.toggleFullScreen()
      },
      stop() {
        this.toggleFullScreen()
      },
      toggleFullScreen() {
        if (!this.isFullScreen) {
          document.documentElement.requestFullscreen()
            .then(() => this.isFullScreen = true)
            .catch(err => console.error("Erreur lors du passage en plein écran:", err));
        } else {
          document.exitFullscreen()
            .then(() => this.isFullScreen = false)
            .catch(err => console.error("Erreur lors de la sortie du plein écran:", err));
        }
      },
      vibrateReady() {
        if (navigator.vibrate && this.enableButtons) {
          navigator.vibrate(50); // Vibrates for ms
        } 
      },
      vibrateConfirm() {
        if (navigator.vibrate && this.enableButtons) {
          navigator.vibrate(150); // Vibrates for ms
        } 
      },
      vibrateError() {
        if (navigator.vibrate) {
          navigator.vibrate(50); // Vibrates for ms
          setTimeout( () => {
            navigator.vibrate(50); // Vibrates for ms
          }, 200)
          setTimeout( () => {
            navigator.vibrate(50); // Vibrates for ms
          }, 400)
          setTimeout( () => {
            navigator.vibrate(50); // Vibrates for ms
          }, 600)
          
        }
      },

      setupWebSocket() {
          this.ws = new WebSocket("ws://192.168.1.92:8080"); // ws://api.server.com/socket

          this.ws.onopen = () => {
              console.log("✅ Connected to WebSocket server", this.ws);
              this.reconnectAttempts = 0; // Reset reconnect attempts on success
          };

          this.ws.onmessage = async (event) => {
            const text = event.data instanceof Blob ? await event.data.text() : event.data;
            console.log("ws.onmessage", text)
            this.messages.push(text);
            if(text.startsWith("ENABLE=")) {
              const [key, value] = text.split('=');
              this.enableButtons = value.toLowerCase() === "true"
              if(this.enableButtons) this.vibrateReady()
            }
          };

          this.ws.onclose = () => {
              console.log("❌ Disconnected from WebSocket server");
              this.reconnectWebSocket(); // ✅ Auto-reconnect
          };

          this.ws.onerror = (error) => {
                console.error("⚠️ WebSocket Error:", error);
                this.ws.close(); // Close and trigger `onclose`
          };
      },
      reconnectWebSocket() {
          if (this.reconnectAttempts >= 5) {
              console.error("❌ Max reconnect attempts reached");
              return;
          }

          const delay = Math.min(5000, (this.reconnectAttempts + 1) * 1000); // Exponential backoff
          console.log(`🔄 Reconnecting in ${delay / 1000} seconds...`);

          setTimeout(() => {
              this.reconnectAttempts++;
              this.setupWebSocket();
          }, delay);
      },
      sendMessage(message) {
          if (this.ws && this.ws.readyState === WebSocket.OPEN) {
              if(!this.enableButtons) {
                this.vibrateError()
                return
              }
              if(message.trim() !== "") {
                this.ws.send(message);
                this.vibrateConfirm()
              }
          } else {
              console.error("⚠️ Cannot send message, WebSocket is disconnected.");
          }
      },
      checkOrientation() {
        if (window.innerHeight > window.innerWidth) {
          alert('For the best experience, please rotate your device to landscape mode.');
        }
      }
    },
    async mounted() { 
      this.setupWebSocket();

      window.addEventListener('resize', this.checkOrientation);
      window.addEventListener('load', this.checkOrientation);
    }
}
</script>
